module.exports = __webpack_public_path__ + "img/step-3.4d27c48c.jpg";